import React from 'react';
import { getSorter } from 'utils/getSorter';
import { percentageToPixels } from 'utils/percentageToPixels';
import ColumnRender from 'components/tables/utils/columnRender';

const CreateColumns = (columns: string[], widths: string[], sorts: string[], tableWith: number) => {
    return columns?.map((column, index) => {
        const sortType = sorts[index];
        const key = column.replace(/\s+/g, '_');
        const sort = getSorter(key, sortType);
        //const hiddenColumns = ['LINK', 'RECID', 'ID'];
        const hiddenColumns = [''];

        return widths[index] !== '0' ? {
            title: hiddenColumns.includes(column) ? '' : column,
            dataIndex: key,
            key: key,
            defaultSortOrder: 'descend',
            width: widths
                ? widths[index] === '0'
                    ? '0'
                    : percentageToPixels(widths[index], tableWith)
                : '10%',
            sorter: sort !== undefined ? sort : false,

            render: (value: string, row: any) => {
                return ColumnRender({ value, column, index, widths, row });
            },
        }: '';
    });
};

export default CreateColumns;
